import React from 'react';
import { observer } from 'mobx-react-lite';
import styled, { ThemeProvider } from 'styled-components';
import { themeState } from 'styleguide/theme';
import { DividerLine } from 'styleguide/DividerLine';
import { View } from 'styleguide/View';
import { P3 } from 'styleguide/Texts';
import { Link } from './Link';
import { t } from 'translations/t';

export const Footer = observer(({ showPricingLink }: { showPricingLink: boolean }) => {
  return (
    <ThemeProvider theme={themeState.current}>
      <Container>
        <DividerLine />
        <BottomContainer>
          <View
            style={{
              width: '100%',
              flexDirection: 'row',
              gap: 24,
              textAlign: 'left',
              marginTop: '4px',
              marginBottom: '4px',
              marginInlineStart: '8px',
            }}
          >
            <Link href="https://www.hevyapp.com/app-terms-conditions">
              <P3 type="tertiary">{t('web.footer.termsAndConditions')}</P3>
            </Link>
            {showPricingLink && (
              <Link href="/pricing">
                <P3 type="tertiary">{t('web.footer.pricing')}</P3>
              </Link>
            )}
            <Link href="https://www.hevyapp.com/privacy-policy">
              <P3 type="tertiary">{t('web.footer.privacyPolicy')}</P3>
            </Link>
            <Link href="https://www.hevyapp.com/contact">
              <P3 type="tertiary">{t('web.footer.contactUs')}</P3>
            </Link>
          </View>
          <View
            style={{
              width: '100%',
              textAlign: 'right',
              marginTop: '4px',
              marginBottom: '4px -8px',
              marginInlineStart: '-8px',
            }}
          >
            <P3 type="tertiary">
              © {new Date().getFullYear()} Hevy Studios S.L. {t('web.footer.allRightReserved')}
            </P3>
          </View>
        </BottomContainer>
      </Container>
    </ThemeProvider>
  );
});

const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  max-width: 1280px;
  margin-inline-start: auto;
  margin-inline-end: auto;
  align-items: center;
  justify-content: center;
  height: 51px;
  @media (max-width: 1024px) {
    display: none;
  }
`;

const BottomContainer = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr;
  margin: 12px 0;
`;
